import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 8px;
`;

export const LabelWrapper = styled.div`
  ${(props) => props.theme.typography.subHeader2};
`;

export const LabelDescription = styled.div`
  ${(props) => props.theme.typography.subHeader2};
  color: ${(props) => props.theme.colors.muted};
  margin-top: 8px;
`;
